<template>
  <div class="c-login__wrapper" v-if="status == 'normal'">
    <header class="c-login__header">
      <a class="c-login__header__title">
        <img
          class="c-login__header__title__icon"
          src="/mc/assets/img/login/logo.png"
          alt="logo"
        />
        <img
          class="c-login__header__title__text"
          src="/mc/assets/img/login/logo-title-text.png"
          alt="logo__text"
        />
      </a>
    </header>
    <main class="c-login__mainWrap">
      <div class="c-login__mainBackgroundImage">
        <img src="/mc/assets/img/login/login-background.png" alt="" />
      </div>
      <div class="c-login__main">
        <div class="c-login__main__container">
          <div class="c-login__loginForm">
            <div class="c-login__loginForm__title">ログイン</div>
            <form ref="ruleForm" @submit.prevent="onLogin">
              <div class="c-login__loginForm__item">
                <div class="c-login__loginForm__item__inputTitle">ID</div>
                <div class="c-login__loginForm__item__inputWrap">
                  <input
                    class="c-login__loginForm__item__input __id"
                    type="text"
                    name="id"
                    v-model.trim="$v.values.id.$model"
                  />
                  <div
                    class="c-login__loginForm__item__inputErrorMessage"
                    v-if="!$v.values.id.required"
                  >
                    必須です
                  </div>
                </div>
              </div>
              <div class="c-login__loginForm__item">
                <div class="c-login__loginForm__item__inputTitle">
                  パスワード
                </div>
                <div class="c-login__loginForm__item__inputWrap">
                  <input
                    class="c-login__loginForm__item__input __password"
                    :type="inputType"
                    name="pw"
                    v-model.trim="$v.values.password.$model"
                  />
                  <div
                    class="c-login__loginForm__item__inputErrorMessage"
                    v-if="!$v.values.password.required"
                  >
                    必須です
                  </div>
                </div>
              </div>
              <div class="c-login__loginForm__checkboxWrap">
                <div class="c-login__loginForm__checkbox">
                  <input
                    class="c-login__loginForm__checkboxInput"
                    type="checkbox"
                    v-model="showPassword"
                    id="cloginpassword"
                  />
                  <label
                    class="c-login__loginForm__checkboxInputLabel"
                    for="cloginpassword"
                    >パスワードを表示</label
                  >
                </div>
                <div class="c-login__loginForm__checkbox">
                  <input
                    class="c-login__loginForm__checkboxInput"
                    type="checkbox"
                    v-model="isChecked"
                    @change="changeCheckbox"
                    id="cloginsave"
                  />
                  <label
                    class="c-login__loginForm__checkboxInputLabel"
                    for="cloginsave"
                    >入力情報を保持</label
                  >
                </div>
              </div>
              <input
                class="c-login__loginForm__button"
                type="submit"
                value="ログイン"
              />
              <div
                class="c-login__form__submitErrorMessage"
                v-if="message !== ''"
              >
                {{ message }}
              </div>
              <div class="c-login__loginForm__forgottenPasswordWrap">
                <div>
                  <a
                    class="c-login__loginForm__forgottenPassword"
                    href="/password-reminder"
                    >パスワードを忘れた方へ</a
                  >
                </div>
                <div class="c-login__loginForm__aside">
                  <a
                    class="c-login__loginForm__aside__item"
                    href="/mc/docs/kiyaku.html"
                    target="_blank"
                    >利用規約</a
                  >
                  <a
                    class="c-login__loginForm__aside__item"
                    href="/mc/docs/faq.html"
                    target="_blank"
                    >よくある質問</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
    <footer class="c-login__footer">
      <p>© Hoosiers Holdings Co., Ltd. ALL RIGHTS RESERVED.</p>
    </footer>
  </div>
  <div class="_login-wrapper" v-else>
    <header class="c-login__header">
      <a class="c-login__header__title">
        <img
          class="c-login__header__title__icon"
          src="/mc/assets/img/login/logo.png"
          alt="logo"
        />
        <img
          class="c-login__header__title__text"
          src="/mc/assets/img/login/logo-title-text.png"
          alt="logo__text"
        />
      </a>
    </header>
    <main class="c-login__errorMainWrap">
      <div class="c-login__err">
        <h2 class="c-login__err__title">エラー</h2>
        <p class="c-login__err__asiteText">
          入力されたIDまたはPasswordに誤りがある可能性がございます。<br />ご確認の上、再度お試しください。
        </p>
        <div class="c-login__err__buttons">
          <a class="c-login__err__button" href="remind.html"
            >パスワードを忘れた方</a
          >
          <a
            class="c-login__err__button"
            href="javascript:void(0);"
            @click="status = 'normal'"
            >戻る</a
          >
        </div>
      </div>
    </main>
    <footer class="c-login__footer">
      <p>© Hoosiers Holdings Co., Ltd. ALL RIGHTS RESERVED.</p>
    </footer>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import User from "../models/user";
import store from "../store";

import firebase from "firebase/app";
import "firebase/messaging"; // for cloud messaging

import userService from "../services/user.service";

export default {
  name: "Login",
  data() {
    return {
      APP_VERSION: process.env.VUE_APP_VERSION,
      APP_NAME: process.env.VUE_APP_NAME,
      status: "normal",
      showPassword: false,
      isChecked: this.$localStorage.get("isSeved", false),
      successful: false,
      user: new User("", "", "", "", "", ""),
      loading: false,
      message: "",
      values: {
        id: "",
        password: "",
      },
    };
  },
  validations: {
    values: {
      id: {
        required,
      },
      password: {
        required,
      },
    },
  },
  watch: {
    isChecked(newValue) {
      console.log("+++ isChecked");
      console.log(newValue);
      this.$localStorage.set("isSeved", newValue);
    },
  },
  computed: {
    inputType: function() {
      return this.showPassword ? "text" : "password";
    },
    isDevelopment() {
      return (
        `${process.env.VUE_APP_MODE}` == "development" ||
        process.env.VUE_APP_NO_REDIRECT == 1
      );
    },
    loggedIn() {
      return store.state.auth.status.loggedIn;
    },
  },
  created() {
    console.log("++++ login.created");
    console.log("this.loggedIn", this.loggedIn);
    if (this.loggedIn) {
      this.$router.push({
        name: "top",
        params: { mc_code: this.currentUser.mansion._id },
      });
    }
  },
  async mounted() {
    console.log("++++ login.mounted");
    await this.$nextTick();
    if (this.$localStorage.get("isSeved")) {
      console.log(`isSeved`);
      this.values.id = this.$localStorage.get("id", "");
      this.values.password = this.$localStorage.get("password", "");
      console.log(this.values);
    }
    this.$emit("changeMansion", "");
  },
  updated() {
    console.log("login.updated");
  },
  methods: {
    changeCheckbox() {
      console.log("changeCheckbox");
      console.log(this.isChecked);
    },
    openTop() {
      // this.$router.push(this.$router.go(-1));

      console.log("openTop");
      const lastPath = this.$store.getters["auth/lastPath"];
      console.log("lastPath", lastPath);
      // this.$router.push({ path: lastPath });
      window.location.replace(lastPath);
      // this.$router.push({
      //   name: "top",
      //   params: { mc_code: this.currentUser.mansion._id },
      // });
    },
    async onLogin() {
      this.loading = true;
      const self = this;
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("error");
        this.loading = false;
        return;
      } else {
        if (this.values.id && this.values.password) {
          try {
            const result = await this.$store.dispatch(
              "auth/login",
              this.values,
            );
            console.log(result);
            if (self.$localStorage.get("isSeved")) {
              self.$localStorage.set("id", self.values.id);
              self.$localStorage.set("password", self.values.password);
            } else {
              self.$localStorage.set("id", "");
              self.$localStorage.set("password", "");
            }

            console.log("+++A");
            let messaging = null;
            if (firebase.messaging.isSupported()) {
              console.log("+++B");
              messaging = firebase.messaging();
              messaging
                .getToken({
                  vapidKey: `${process.env.VUE_APP_FIREBASE_VAPID_KEY}`,
                })
                .then(currentToken => {
                  console.log("+++C");
                  if (currentToken) {
                    console.log(`login currentToken=${currentToken}`);
                    userService.setToken(currentToken);
                    console.log("++OK");
                    this.openTop();
                    // this.$router.push(this.$router.go(-1));
                    // this.$router.push({
                    //   name: "top",
                    //   params: { mc_code: this.currentUser.mansion._id },
                    // });
                  } else {
                    // Show permission request.
                    console.log(
                      "No registration token available. Request permission to generate one.",
                    );
                    // Show permission UI.
                    // updateUIForPushPermissionRequired();
                    // setTokenSentToServer(false);
                    // if (this.currentUser.email) {
                    this.openTop();
                    // this.$router.push(this.$router.go(-1));
                    // this.$router.push({
                    //   name: "top",
                    //   params: { mc_code: this.currentUser.mansion._id },
                    // });
                  }
                })
                .catch(err => {
                  console.log(
                    "An error occurred while retrieving token. ",
                    err,
                  );

                  // if (this.currentUser.email) {

                  this.openTop();
                  // this.$router.push(this.$router.go(-1));
                  // this.$router.push({
                  //   name: "top",
                  //   params: { mc_code: this.currentUser.mansion._id },
                  // });
                });
            } else {
              console.log("+++++ login ++");
              console.log(this.currentUser);
              // if (this.currentUser.email) {

              this.openTop();
              // this.$router.push(this.$router.go(-1));
              // this.$router.push({
              //   name: "top",
              //   params: { mc_code: this.currentUser.mansion._id },
              // });
            }
          } catch (error) {
            this.status = "error";
            console.log(error);
            console.log("singin erro!");
            this.successful = false;
            this.loading = false;
            console.log(error);
            this.message = "ログインできませんでした。";
          }
        }
      }
    },
  },
};
</script>

<style></style>
